import { Children } from 'react';
import cx from 'classnames';

import { ScrollCarouselProps } from './ScrollCarousel.types';

import styles from './ScrollCarousel.module.scss';

const toLength = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const ScrollCarousel = ({
  as: List = 'ul',
  bleed,
  children,
  className,
  'data-testid': testId,
  gap = 0,
  gutter,
  itemsPerView,
  label,
}: ScrollCarouselProps) => {
  const items = Children.toArray(children);

  const listStyle = {
    ...(bleed ? { '--scroll-carousel-bleed': toLength(bleed) } : {}),
    ...(gutter ? { '--scroll-carousel-gutter': toLength(gutter) } : {}),
    '--scroll-carousel-gap': toLength(gap),
    ...(itemsPerView ? { '--scroll-carousel-items-per-view': itemsPerView } : {}),
  } as React.CSSProperties;

  return (
    <List
      aria-label={label}
      className={cx(styles.list, className)}
      data-fixed-width={itemsPerView ? '' : undefined}
      data-testid={testId}
      style={listStyle}
    >
      {items.map((child, index) => (
        <li key={(child as { key?: string }).key ?? index} className={styles.item}>
          {child}
        </li>
      ))}
    </List>
  );
};
